import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AUTHORIZATION_HEADER, TOKEN } from 'src/app/core/constants/auth.constants';
import { SsoConfigResponse } from 'src/app/core/interfaces/sso.interface';
import { ReturnUrlService } from '../return-url/return-url.service';
import { CompanyService } from '../company/company.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SsoService {
  private http = inject(HttpClient);

  private returnUrlService = inject(ReturnUrlService);

  private location = inject(DOCUMENT).location;

  private companyService = inject(CompanyService);

  errorMessage = '';

  getSsoConfig(systemName: string): Observable<SsoConfigResponse> {
    return this.http.get<SsoConfigResponse>(environment.ssoApiUrl(this.companyService.name), {
      params: { system_name: systemName },
    });
  }

  loginWithSso(
    code: string,
    state: string,
    systemName: string,
    redirectUri: string,
  ): Observable<any> {
    return this.http
      .post(
        environment.ssoApiUrl(this.companyService.name),
        { code, state, system_name: systemName, redirect_uri: redirectUri },
        { observe: 'response' },
      )
      .pipe(
        tap((response) => {
          const token = response.headers.get(AUTHORIZATION_HEADER);
          if (token) {
            const url = new URL(this.returnUrlService.returnUrl);
            url.searchParams.set(TOKEN, token);
            this.location.replace(url.toString());
          }
        }),
      );
  }

  redirectToSso(ssoClientUrl: string): void {
    const url = new URL(ssoClientUrl);
    url.searchParams.set('redirect_uri', this.buildRedirectUri());
    this.location.replace(url.toString());
  }

  buildRedirectUri(): string {
    const uri = new URL(`${this.location.origin}${this.location.pathname}`);
    const returnUrl = new URLSearchParams(this.location.search).get('returnUrl');
    if (returnUrl) {
      uri.searchParams.set('returnUrl', returnUrl);
    }
    return uri.toString();
  }
}
